export const ERROR_MESSAGES = {
  General: 'Unexpected error, please try again or contact support',
  SessionExpired: 'Your session has expired, please try to login again',
};

const fetchErrorFromResponse = (
  response?: any,
  fallback: string = ERROR_MESSAGES.General
): string => {
  if (!response) {
    return fallback;
  }

  if (response.code === 1062 || response.code === 1012) {
    return ERROR_MESSAGES.SessionExpired;
  }

  return (
    response.message ??
    response.error?.message ??
    response.error ??
    response.data?.message ??
    fallback
  );
};

export default fetchErrorFromResponse;
